<template>
  <div class="card">
    <div class="card-header" v-if="canSend">
      <form v-on:submit="submit">
        <div class="input-group">
          <b-form-input v-model="authorName" :state="authorName === '' ? false : null" type="text" placeholder="Nome autore..." :disabled="inputDisabled"
                        class="form-control"></b-form-input>
        </div>
      </form>
    </div>
    <div class="card-body overflow-auto chat" ref="chatContainer">
      <div ref="chatContent">
        <div
          v-for="(message, index) in messages"
          :key="message.id"
          @mouseover="over(index)"
          @mouseleave="leave">
          <div class="row">
            <div class="col">
              <b>{{ message.author }}</b>
              <span class="small" :id="'message-'+message.id">
                            {{ message.created_at | relative }}
                        </span>
              <b-tooltip :target="'message-'+message.id" triggers="hover">
                {{ message.created_at | exact }}
              </b-tooltip>
            </div>
            <div class="col-auto" :style="{ visibility: hover === index ? 'visible' : 'hidden' }">
              <button @click="replyTo = message" class="btn btn-primary btn-sm"><i class="fas fa-reply"></i></button>
              <button @click="showDeleteConfirmation(message)" class="btn btn-danger btn-sm"><i class="fas fa-times"></i></button>
            </div>
          </div>
          <div class="small" v-if="message.reply_to !== null">
            <b>In risposta a {{ message.reply_to_author }}:</b> {{ message.reply_to.content }}
          </div>
          {{ message.content }}
          <hr />
        </div>
      </div>
    </div>
    <div class="card-footer" v-if="canSend">
      <div class="small mb-2" v-if="replyTo !== null">
        <div class="row">
          <div class="col">
            <b>In risposta a {{ replyTo.author }}:</b><br />
            {{ replyTo.content }}
          </div>
          <div class="col-auto">
            <button @click="replyTo = null" class="btn btn-sm btn-secondary"><i class="fas fa-times"></i></button>
          </div>
        </div>
      </div>
      <form v-on:submit="submit">
        <div class="input-group">
          <input v-model="newMessage" type="text" placeholder="Messaggio..." :disabled="inputDisabled"
                 class="form-control">
          <span class="input-group-append">
                      <input :disabled="inputDisabled" type="submit" class="btn btn-primary" value="Invia"/>
                    </span>
        </div>
      </form>
    </div>
    <b-modal
      ref="deleteModal"
      title="Elimina messaggio"
      header-bg-variant="danger"
      header-text-variant="light"
      ok-variant="danger"
      ok-title="Elimina"
      v-on:ok="deleteMessage"
      cancel-title="Annulla">
      <div v-if="messageToDelete !== null">
      Sei sicuro di voler eliminare il messaggio scritto da {{ messageToDelete.author }}?
      <b>Messaggio:</b><br />
      {{ messageToDelete.content }}
      </div>
    </b-modal>
  </div>
</template>

<script>
  const axios = require('axios');
  const moment = require('moment');

  export default {
    name: "Chat",
    data() {
      return {
        authorName: this.$props.defaultAuthorName,
        messages: [],
        newMessage: "",
        inputDisabled: false,
        hover: null,
        replyTo: null,
        messageToDelete: null,
      }
    },
    filters: {
      relative: function (date) {
        moment.locale('it');
        return moment(date).fromNow();
      },
      exact: function (date) {
        moment.locale('it');
        return moment(date).format("LLL");
      }
    },
    props: {
      canSend: {
        type: Boolean,
        default: false
      },
      defaultAuthorName: String,
      eventId: Number,
      baseUrl: String,
    },
    mounted() {
      axios.get(`${this.baseUrl}/old_messages`).then(function (response) {
        this.messages = response.data;
        Echo.channel(`event.${this.eventId}`)
          .listen('ChatMessageReceived', (e) => {
            this.messages.push(e.chatMessage);
          })
        .listen('ChatMessageDeleted', (e) => {
          this.messages = this.messages.filter((item) => {
            return item.id !== e.chatMessageId;
          })
        });
      }.bind(this));
    },
    updated() {
      this.$refs.chatContainer.scrollTop = this.$refs.chatContent.clientHeight;
    },
    methods: {
      submit: function (event) {
        event.preventDefault();

        if (this.newMessage === "") return;
        if (this.authorName === "") return;

        this.inputDisabled = true;
        let body = {
          message: this.newMessage,
          fake_author: this.authorName,
        }
        if (this.replyTo !== null) {
          body.reply_to_id = this.replyTo.id
        }

        axios.post(`${this.baseUrl}/send_message`, body)
          .then(function () {
            this.newMessage = "";
            this.inputDisabled = false;
            this.replyTo = null;
          }.bind(this));
      },
      over(index) {
        let initialHeight = this.$refs.chatContainer.scrollTop;
        this.hover = index;
        this.$nextTick(() => {
          this.$refs.chatContainer.scrollTop = initialHeight;
        })
      },
      leave() {
        let initialHeight = this.$refs.chatContainer.scrollTop;
        this.hover = null;
        this.$nextTick(() => {
          this.$refs.chatContainer.scrollTop = initialHeight;
        })
      },
      showDeleteConfirmation(message) {
        this.messageToDelete = message;
        this.$refs.deleteModal.show();
      },
      deleteMessage() {
        if (this.messageToDelete === null) return;
        axios.post(`${this.baseUrl}/delete_message`, { chat_message_id: this.messageToDelete.id });
        this.messageToDelete = null;
      }
    },
  }
</script>

<style scoped>
  .chat {
    height: 400px;
  }
</style>
